export default theme => ({
    root: {
        flex: '1 0 auto',
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: theme.spacing(2),
        // Visually hide the label on the collapsed rail but keep it in the
        // accessibility tree, so each icon still has its name for screen readers
        // (this replaces the per-item hover tooltips).
        '&.collapsed .MuiListItemText-root': {
            position: 'absolute',
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: 'hidden',
            clip: 'rect(0, 0, 0, 0)',
            whiteSpace: 'nowrap',
            border: 0,
        },
        '&.collapsed .expand-icon': {
            display: 'none',
        },
    },
    listItem: {
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        width: 'auto',
        // Fixed height so a row is the exact same size collapsed or expanded —
        // the revealed label must not grow the row and push content down.
        height: 40,
        // Spacing lives on the top only (zero bottom) so it can't margin-collapse
        // differently when a closed submenu Collapse sits between rows on expand.
        marginTop: theme.spacing(0.5),
        marginBottom: 0,
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        // Left padding sits the icon on the collapsed square's centerline, so it
        // holds that exact spot as the row widens (no shift on the slide).
        paddingLeft: theme.spacing(1.75),
        paddingRight: theme.spacing(1.5),
        borderRadius: theme.spacing(1),
        border: 'none',
        color: theme.palette.common.white,
        transition: theme.transitions.create('background-color'),
        '&:hover': {
            backgroundColor: theme.palette.secondary.hover,
        },
    },
    activeListItem: {
        backgroundColor: theme.palette.secondary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        '& $listItemText': {
            color: theme.palette.secondary.contrastText,
        },
        '& $listItemIcon': {
            color: theme.palette.secondary.contrastText,
        },
    },
    listItemIcon: {
        minWidth: 'auto',
        marginRight: theme.spacing(1.5),
        color: theme.palette.common.white,
    },
    listItemText: {
        fontWeight: 500,
        color: theme.palette.common.white,
    },
    previewChip: {
        height: 16,
        fontSize: '0.6rem',
        fontWeight: 600,
        color: theme.palette.common.white,
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        marginLeft: theme.spacing(1),
        '& .MuiChip-label': {
            padding: '0 6px',
        },
    },
    listMenuExpanded: {
        backgroundColor: theme.palette.tertiary.light,
    },
    submenu: {
        overflowX: 'hidden',
    },
    submenuItem: {
        height: 36,
        paddingLeft: theme.spacing(6),
    },
    divider: {
        margin: theme.spacing(1, 2),
        borderColor: 'rgba(255, 255, 255, 0.12)',
    },
});
